<template>
  <div class="mobile-account-container">
    <div class="mobile-account-title">{{ $t('delivered') }}</div>
    <div class="mobile-account-info">
      <div class="mobile-account-item-container">
        <div class="mobile-account-item-title">{{ $t('delivery_for') }}</div>
        <div class="mobile-account-item-txt">{{ userDetails.FirstName }} {{ userDetails.LastName }}</div>
        <div v-if="userDetails && userDetails.phone" class="mobile-account-item-txt">
          {{$t('phone_no')}}: {{ userDetails.phone }}
        </div>
      </div>
      <div class="mobile-account-item-container" v-if="false">
        <div class="mobile-account-item-title">Payment Information</div>
        <div class="mobile-account-item-txt">My Card</div>
        <div class="mobile-account-item-txt">
          Card number : **************7564
        </div>
        <div class="mobile-account-item-txt">
          Expiry Date: 06/22
        </div>
      </div>
      <div class="mobile-account-item-container">
        <div class="mobile-account-item-title">{{ $t('delivery_method') }}</div>
        <div class="mobile-account-item-txt">{{ orderDetail.ShippingMethod }}</div>
        <div v-if="orderDetail && orderDetail.ShippingMethod === 'Delivery'" class="mobile-account-item-txt">
          {{ $t('delivery_date') }}:{{ orderDetail.TimeSlot }}
        </div>
      </div>
      <div class="mobile-account-item-container"
           v-if="orderDetail.ShippingMethod === 'Delivery'">
        <div class="mobile-account-item-title">{{ $t('shipping_address') }}</div>
        <div class="mobile-account-item-txt">
          {{ orderDetail.Shipping_Address.Street }}, {{ orderDetail.Shipping_Address.City }}
          WA, {{ orderDetail.Shipping_Address.Zip }}
        </div>
        <div class="mobile-account-item-txt"
             v-if="orderDetails && orderDetails.Shipping_Address && orderDetails.Shipping_Address.Cellphone">
          {{ orderDetails.Shipping_Address.Cellphone }}
        </div>
      </div>
      <div class="mobile-account-item-container">
        <div class="mobile-account-item-title">{{ $t('billing_address') }}</div>
        <div class="mobile-account-item-txt">
          {{ billingAddress.AddressName }}, {{ billingAddress.City }} {{ billingAddress.State }},
          {{ billingAddress.Zip }}
        </div>
      </div>

<!--      orderSummary-->
      <div class="mobile-account-item-container">
        <div class="mobile-account-item-header">
          <div class="mobile-account-item-title">{{ $t('orderSummary') }}</div>
<!--          <div @click="goToReview">{{$t('rate_experience')}}</div>-->
        </div>
        <div class="mobile-account-item-content">
          <div class="mobile-account-card"
              v-for="(item, index) in orderDetail.Sales_Order_Line"
              :data-index="'Sales_Order_Line_'+index"
              :key="'Sales_Order_Line_'+index">
            <div class="mobile-account-desc">
              <div class="mobile-account-name">{{ curIsEnglish ? item.ProductName : item.ProductDescription }}</div>
              <div class="mobile-account-brand">{{ curIsEnglish ? item.English_Details_Brand : item.Chinese_Details_Brand }}</div>
            </div>
            <div class="mobile-account-quant">{{ item.Quantity }}</div>
            <div class="mobile-account-price">${{ item.TotalPrice }}</div>
          </div>
        </div>

<!--        Coupon-->
        <div class="mobile-account-item-container" v-if="false">
          <div class="mobile-account-item-title">Coupon</div>
          <div class="mobile-account-item-txt">
            -$10 First order coupon code
          </div>
        </div>
      </div>
    </div>
    <!--      order-cost-->
    <div class="order-cost">
      <div class="cost-row">
        <div class="cost-title">{{ $t('subtotal_afm') }}</div>
        <div class="cost-txt">${{ orderDetail.TotalPrice }}</div>
      </div>
      <div class="cost-row">
        <div class="cost-title">{{ $t('discount') }}</div>
        <div class="cost-txt">-${{ orderDetail.Savings }}</div>
      </div>
      <div class="cost-row">
        <div class="cost-title">{{$t('shipping_fee')}}</div>
        <div class="cost-txt">${{ orderDetail.Delivery }}</div>
      </div>
      <div class="cost-row">
        <div class="cost-title">{{$t('tax_afm')}}</div>
        <div class="cost-txt">${{ orderDetail.TaxAmount }}</div>
      </div>
      <div class="cost-total-row">
        <div class="cost-total-title">{{ $t('total_afm') }}</div>
        <div class="cost-total-txt">${{ orderDetail.GrandTotal }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mobile-account",
  props: {
    orderDetail: {
      type: Object,
      required: true
    },
    orderDetails: {
      type: Array,
      required: true
    },
    billingAddress: {
      type: Object,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    curIsEnglish: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    goToReview() {
      this.$emit('goToReview')
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-account-container {
  width: 100%;
  padding: 46px 25px;
  background-color: #f5f6f7;

  .mobile-account-title {
    font-weight: 900;
    color: #131e1e;
    font-family: Raleway;
    font-size: 18px;
    margin-bottom: 32px;
  }

  .mobile-account-info {
    display: flex;
    flex-direction: column;

    .mobile-account-item-container {
      margin-bottom: 26px;

      .mobile-account-item-title {
        font-family: 'Source Sans Pro';
        font-size: 14px;
        font-weight: 900;
        color: #131e1e;
        margin-bottom: 8px;
      }
      .mobile-account-item-txt {
        font-family: 'Source Sans Pro';
        font-size: 10px;
        font-weight: 600;
        color: #8ba39e;
        margin-bottom: 5px;
      }
    }

    .mobile-account-item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .mobile-account-item-content {
      .mobile-account-card {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .mobile-account-desc {
          flex: 1;
          font-family: 'Source Sans Pro';
          font-size: 10px;
          font-weight: 600;
          color: #8ba39e;
          margin-bottom: 17px;
          margin-right: 8%;

          .mobile-account-name {
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .mobile-account-brand {
            text-decoration:underline;
            font-size: 7px;
          }
        }

        .mobile-account-quant {
          width: 48px;
          height: 18px;
          background-color: black;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Source Sans Pro';
          font-size: 7.2px;
          font-weight: 900;
          margin: 0 10px;
        }
        .mobile-account-price {
          width: 20%;
          font-family: 'Source Sans Pro';
          font-size: 9px;
          font-weight: 900;
          color: #131e1e;
          text-align: right;
        }
      }
    }

  }

  .order-cost {
    width: 100%;

    .cost-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;

      .cost-title {
        font-family: 'Source Sans Pro';
        font-size: 9px;
        font-weight: 600;
        color: #8ba39e;
      }

      .cost-txt {
        font-family: 'Source Sans Pro';
        font-size: 12px;
        font-weight: 600;
        color: #8ba39e;
      }
    }

    .cost-total-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 5px;

      .cost-total-title {
        font-family: 'Source Sans Pro';
        font-size: 21px;
        font-weight: 900;
        color: #131e1e;
      }
      .cost-total-txt {
        font-family: 'Source Sans Pro';
        font-size: 18px;
        font-weight: 900;
        color: #131e1e;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mobile-account.vue